import Link, { LinkProps } from 'next/link';
import Arrow from 'components/Misc/Arrow';

export interface ArrowLinkProps extends LinkProps {
  children?: React.ReactNode;
  className?: string;
  inverted?: boolean;
  pointingLeft?: boolean;
  disabled?: boolean;
}

export default function ArrowLink({
  className,
  children,
  inverted,
  pointingLeft,
  disabled,
  ...props
}: ArrowLinkProps) {
  if (disabled) {
    return (
      <span className={`${className ? className : ''} cursor-not-allowed`}>
        <Arrow inverted={inverted} pointingLeft={pointingLeft} disabled>
          {children}
        </Arrow>
      </span>
    );
  }

  return (
    <Link {...props} className={`${className ? className : ''}`}>
      <Arrow inverted={inverted} pointingLeft={pointingLeft}>
        {children}
      </Arrow>
    </Link>
  );
}
